import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

const updateCustomer = async ({
  id,
  body,
}: {
  id: string;
  body: ApiDefinition['/customers/update/{customerId}']['PUT']['body'];
}): Promise<ApiDefinition['/customers/update/{customerId}']['PUT']['response']> => {
  const data = await noodleApiClient.put(`/customers/update/${id}`, body);
  return data.data;
};

export default updateCustomer;
